import * as React from 'react'
import { Helmet } from 'react-helmet'

import { setGAPageView } from '../../../../services/analytics/google-analytics'

import { EmbedRoot, EmbedFrame } from './MainView.style'
import Header from '../../../../components/ui/Header/container/Header'

const LEASING_INQUIRY_FORM_URL =
  'https://ayalalandleasing.my.site.com/ayala/s/leadform?type=AMG&source=website'

function MainView(props) {
  const { location } = props

  React.useEffect(() => {
    if (location) setGAPageView(location.pathname)
  }, [location])

  return (
    <>
      <Helmet>
        <title>Leasing Inquiry</title>
      </Helmet>
      <Header variant="leasing" />
      <EmbedRoot>
        <EmbedFrame
          src={LEASING_INQUIRY_FORM_URL}
          title="Ayala Land leasing inquiry form"
          loading="lazy"
        />
      </EmbedRoot>
    </>
  )
}

export default MainView
